import { render, staticRenderFns } from "./advantageTech.vue?vue&type=template&id=ddacafaa&scoped=true"
import script from "./advantageTech.vue?vue&type=script&lang=js"
export * from "./advantageTech.vue?vue&type=script&lang=js"
import style0 from "./advantageTech.vue?vue&type=style&index=0&id=ddacafaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddacafaa",
  null
  
)

export default component.exports